import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
import { IConfirmationStep } from "@faire/web-api--source/faire/samples/IConfirmationStep";
import { IMessageToBrandStep } from "@faire/web-api--source/faire/samples/IMessageToBrandStep";
import { IReviewRequestStep } from "@faire/web-api--source/faire/samples/IReviewRequestStep";
import { ISelectProductsStep } from "@faire/web-api--source/faire/samples/ISelectProductsStep";

type SamplesRequestStore = {
  // need brandToken to submit the request to BE
  brandToken?: string;
  inviteToken?: string;
  // fields required to send on submission
  retailerProductRequestMessage: string;
  retailerIntroductionMessage: string;
  // we want to extract this so we don't update the entire object
  // during selection
  products: Array<ISelectProductsStep.IProductInfo>;

  // fields required to render the modal
  selectProductsStep?: ISelectProductsStep;
  messageToBrandStep?: IMessageToBrandStep;
  reviewRequestStep?: IReviewRequestStep;
  confirmationStep?: IConfirmationStep;
};

const {
  useStore: useSamplesRequestStore,
  Provider: SamplesRequestStoreProvider,
} = createContextStore<SamplesRequestStore>(
  {
    retailerProductRequestMessage: "",
    retailerIntroductionMessage: "",
    products: [],
  },
  { name: "SamplesRequestStore" }
);

export { useSamplesRequestStore, SamplesRequestStoreProvider };
